import { LinkButton } from "components/buttons";
import profitrate from "assets/pdf/deposits/Board Profit Rate 080723.pdf";
import pds from "assets/pdf/deposits/TD-i PDS V2_2019.pdf";
import { Link, useNavigate } from "react-router-dom";
import { handleOpenPdf } from "utils";
import placementForm from 'assets/pdf/deposits/Term Deposit Placement Form_23.pdf';

const PlacementCMTD = () => {
  const navigate = useNavigate();
  return (
    <div className="text-grey-color">
        <ul>
          <li><Link onClick={() => handleOpenPdf(placementForm)}>Click here</Link> to download and complete all forms:</li>
            <div>1.&emsp;Term Deposit Placement Form</div>
        </ul>
        <ul>
          <li>Please read and understand the following:</li>
          <div>2.&emsp;<Link to="/tnc">Terms and Conditions for Commodity Murabahah Term Deposit Account-i</Link></div>
          <div>3.&emsp;<Link onClick={() => handleOpenPdf(pds)}>Product Disclosure Sheet Commodity Murabahah Term Deposit Account-i</Link></div>
        </ul>
        <div className="p-2 border rounded background-indigo my-3">
          <div><strong>Important Notice</strong>/Notis Penting:</div>
          <ul>
            <li><strong>All term deposit placement applications received on or before 3.00 pm will be processed on the same business day. Applications received after the cut off time of 3:00 pm shall be processed on the next business day;</strong> / Semua permohonan peletakan deposit berjangka yang diterima pada atau sebelum pukul 3.00 petang akan di proses pada hari yang sama. Permohonan yang diterima selepas 3:00 petang akan diproses pada hari bekerja berikutnya.</li>
            <li><strong>Term deposit placement applications are subject to accuracy and completeness of information along with the necessary verification before the applications can be processed;</strong> / Permohonan peletakan deposit berjangka adalah tertakluk kepada ketepatan dan kelengkapan maklumat beserta dengan pengesahan yang diperlukan sebelum permohonan tersebut di proses.</li>
            <li><strong>Successful term deposit placement applications will be notified via your registered email with the bank.</strong> / Permohonan peletakan deposit berjangka yang berjaya akan dimaklumkan melalui emel anda yang telah didaftarkan dengan pihak bank.</li>
            <li><strong>Term deposit certificates for successful placements will be sent to you via email on the next business day.</strong> / Sijil deposit berjangka akan dihantar kepada emel anda pada hari bekerja berikutnya.</li>
          </ul>
        </div>
        <div className="my-3 d-flex gap-3">
          <LinkButton text="Profit Rate" onClick={() => handleOpenPdf(profitrate)} />
          <LinkButton text="Product Information" onClick={() => navigate('/personal/deposits/commodity-murabahah-td-i')} />
        </div>
        <ul>
          <li>Submit all of the above to <a href="mailto:onlineaccountopening@alrajhibank.com.my">onlineaccountopening@alrajhibank.com.my</a></li>
        </ul>
      </div>
  );
};

export default PlacementCMTD;
